import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MedicalConditionsVaccinesModel } from '../../../models/master-data/medical-conditions-vaccines.model';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { Utility } from '../../../common/utility';
import { MedicalConditionsVaccinesService } from './medical-conditions-vaccines.service';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { AppMessages } from '../../../shared/constants/messages';

@Component({
    selector: 'add-new-medical-condition-vaccine',
    templateUrl: 'add-new-medical-condition-vaccine-popup.component.html',
    providers: [MedicalConditionsVaccinesService]
})

export class AddNewMedicalConditionVaccineComponent implements OnInit {
    title: string;
    medicalConditionVaccineForm: FormGroup;
    medicalConditionVaccineModel = new MedicalConditionsVaccinesModel();
    medicalConditionVaccineId: any;
    medicalConditionVaccineName: any;
    formMessage = '';
    vaccines: any;
    public isSuccess = false;
    constructor(
        private formBuilder: FormBuilder,
        private baseService: BaseService,
        public dialogService: DialogService,
        public utility: Utility,
        private medicalConditionsVaccinesService: MedicalConditionsVaccinesService,
        public dialogRef: MdDialogRef<AddNewMedicalConditionVaccineComponent>,
        @Inject(MD_DIALOG_DATA) public data: any) { }

    ngOnInit() {
        this.medicalConditionsVaccinesService.getVaccinesList().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.vaccines = data;
                    this.removeDuplicate(this.data.dataList, this.vaccines);
                }
            },
            error => {
            }
        );
        this.medicalConditionVaccineName = this.data.medicalConditionName;
        this.medicalConditionVaccineId = this.data.medicalConditionId;
        this.createForm();
        this.medicalConditionVaccineForm.controls['MedicalConditionId'].setValue(this.medicalConditionVaccineId);
    }
    createForm() {
        this.medicalConditionVaccineForm = this.formBuilder.group({
            Vaccine: [[], [Validators.required]],
            MedicalConditionId: []
        });
    }

    onVaccineChange(event) {
        this.medicalConditionVaccineForm.controls['Vaccine'].setValue(event.value);
        // this.medicalConditionVaccineForm.markAsDirty();
    }

    addMedicalCondition() {
        this.medicalConditionsVaccinesService.addNewMedicalConditionVaccine(this.medicalConditionVaccineForm.value).subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.dialogService.openSuccessDialog({ message: data.message });
                    this.isSuccess = true;
                    this.close();
                }
            }
        )
    }

    onSubmit() {
        if (this.medicalConditionVaccineForm.valid) {
            this.addMedicalCondition();
        }
    }

    close() {
        this.dialogRef.close(this.isSuccess);
    }

    removeDuplicate(listData, listCheck) {
        listData.forEach(data => {
            if (listCheck.findIndex(item => item.name === data.name) >= 0) {
                listCheck.splice(listCheck.findIndex(item => item.name === data.name), 1);
            }
        });
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/medical-conditions-vaccines/add-new-medical-condition-vaccine-popup.component.ts